var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.83334H3.00526C3.85578 3.83334 4.56986 4.47375 4.6621 5.31926L5.3379 11.5141C5.43014 12.3596 6.14422 13 6.99474 13H14.205C14.9669 13 15.6317 12.4834 15.82 11.7452L16.9699 7.23592C17.2387 6.18212 16.4425 5.15741 15.355 5.15741H5.5M5.52063 16.0208H6.14563M5.52063 16.6458H6.14563M14.6873 16.0208H15.3123M14.6873 16.6458H15.3123M6.66667 16.3333C6.66667 16.7936 6.29357 17.1667 5.83333 17.1667C5.3731 17.1667 5 16.7936 5 16.3333C5 15.8731 5.3731 15.5 5.83333 15.5C6.29357 15.5 6.66667 15.8731 6.66667 16.3333ZM15.8333 16.3333C15.8333 16.7936 15.4602 17.1667 15 17.1667C14.5398 17.1667 14.1667 16.7936 14.1667 16.3333C14.1667 15.8731 14.5398 15.5 15 15.5C15.4602 15.5 15.8333 15.8731 15.8333 16.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.832d29fea14e672e355ff3be482eeff3.svg";
export { ForwardRef as ReactComponent };